import { FC } from 'react';
import '../ArticleComponent.scss';
import './Article1.scss';
import {
	Section1,
	Section2,
	Section3,
	Section4,
	Section5,
	Section6,
	Images,
	Links
} from './article1_model';
import { ButtonComponent } from '../../../UI/ButtonComponent/ButtonComponent';
import AppStore from '../../../../assets/images/articles/ios_appstore.svg';

const Article1Component: FC = () => {
	const handleNavigateToStartDiscovering = () => {
		window.open(Links.beaconHome, '_blank', 'noopener');
	};
	const handleImgAppStore = () => {
		window.open(Links.appstore, '_blank', 'noopener');
	};
	return (
		<div className='page'>
			<div className='section--intro'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section1.heading}</h3>
					<p>
						{' '}
						<a href={Links.newtopia} className='info-400' target='_blank' rel='noopener'>
							Newtopia Now
						</a>
						<span className='info-400'>{Section1.content1}</span>
					</p>
					<p className='info-700'>{Section1.content2}</p>
					<img src={Images.beaconHome} alt='Beacon Home' className='non-clickable'></img>
					<p className='info-400 nospace'>{Section1.content3}</p>
				</div>
			</div>

			<div className='section--image-right-wave first-second'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section2.heading}</h3>
					<p className='info-600 nospace'>{Section2.content1.content}</p>
					<div className='imageRightContentLeft'>
						<div className='content'>
							<h4 className='section-subheading'>{Section2.content2.heading}</h4>
							<ol type='1'>
								<li>
									<span className='info-700'>{Section2.content2.subContent1.heading}</span>{' '}
									<span className='info-400'>{Section2.content2.subContent1.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section2.content2.subContent2.heading}</span>{' '}
									<span className='info-400'>{Section2.content2.subContent2.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section2.content2.subContent3.heading}</span>{' '}
									<span className='info-400'>{Section2.content2.subContent3.content}</span>
								</li>
							</ol>
						</div>
						<div className='image'>
							<img src={Images.filters} alt='Filters' className='non-clickable' />
						</div>
					</div>
					<p className='info-400'>{Section2.content3.content}</p>
				</div>
			</div>

			<div className='section--image-right'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section3.heading}</h3>
					<p className='info-600 nospace'>{Section3.content1}</p>

					<div className='imageRightContentLeft'>
						<div className='content'>
							<h4 className='section-subheading'>{Section3.subheading}</h4>
							<p>
								{' '}
								<span className='info-700'>{Section3.content2.boldcontent}</span>
								<span className='info-400'>{Section3.content2.content}</span>
							</p>
							<p className='info-400'>{Section3.content3}</p>
						</div>
						<div className='image'>
							<img src={Images.newtopia} alt='Newtopia Now' className='non-clickable' />
						</div>
					</div>
					<p className='info-600'>{Section3.content4}</p>
				</div>
				<div className='app-store'>
					<img src={AppStore} onClick={handleImgAppStore} />
				</div>
			</div>

			<div className='section--image-left'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section4.heading}</h3>
					<p className='info-600'>{Section4.content1}</p>
					<div className='imageLeftContentRight'>
						<div className='image'>
							<img src={Images.poster} alt='Description' className='non-clickable' />
						</div>
						<div className='content'>
							<h4 className='section-subheading'>{Section4.subheading}</h4>
							<p className='info-400'>{Section4.content2}</p>
						</div>
					</div>
				</div>
			</div>

			<div className='section--noimage first-first'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section5.heading}</h3>
					<p>
						{' '}
						<span className='info-700'>{Section5.content1.boldcontent}</span>
						<span className='info-400'>{Section5.content1.content}</span>
					</p>
					<p>
						{' '}
						<span className='info-700'>{Section5.content2.boldcontent}</span>
						<span className='info-400'>{Section5.content2.content}</span>
					</p>
				</div>
			</div>

			<div className='section--noimage'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section6.heading}</h3>
					<p className='info-400'>{Section6.content1}</p>
					<br></br>
					<br></br>
					<p className='info-400'>{Section6.content2}</p>
					<div className='button-container'>
						<ButtonComponent
							text={'Start Discovering Now'}
							onClick={handleNavigateToStartDiscovering}
							style={'rounded-button primary addToCart'}
							icon={<i className='ri-arrow-right-s-line arrowIcon'></i>}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Article1Component;
